window.Minus40ApiError = class Minus40ApiError
{
    status = 0;
    code = "";
    message = "";
    lineErrors = {};
    info= {};
}

window.CooldownHandler = class CooldownHandler {

    cooldownCallback = null;
    shortCooldownDelay = 500;
    longCooldownDelay = 600;
    useShortDelayAfter = 500;
    lastCooldownSetAt = 0;

    checkForCooldown (callback) {
        const doSetTimeOut = !this.cooldownCallback;
        this.cooldownCallback = callback;
        if(doSetTimeOut){
            const useShortDelay = Date.now() - this.lastCooldownSetAt > this.useShortDelayAfter;

            setTimeout(() => {
                this.lastCooldownSetAt = Date.now();
                const cooldownCallback = this.cooldownCallback;
                this.cooldownCallback = null;
                if(cooldownCallback){
                    cooldownCallback()
                }
            }, useShortDelay ? this.shortCooldownDelay : this.longCooldownDelay);
        }
    }
}